import { render, staticRenderFns } from "./jiagecaiji.vue?vue&type=template&id=b7bf7d56&scoped=true"
import script from "./jiagecaiji.js?vue&type=script&lang=js&external"
export * from "./jiagecaiji.js?vue&type=script&lang=js&external"
import style0 from "./jiagecaiji.scss?vue&type=style&index=0&id=b7bf7d56&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bf7d56",
  null
  
)

export default component.exports